import React from 'react';
import { useNavigate } from 'react-router-dom';
import TitleActionLine from './title_action_line';

import StandardBoxList from './standard_box_list';
import TextButton from './buttons/text_button';
import PropList from './prop_list';

import MediaIngest from '../lib/media_ingest';

import { byteFormat } from '../tools/util';

export default function UploadProgress(props) {
  const { path, volumeId } = props;
  const navigate = useNavigate();
  const list = MediaIngest.useUploadList();
  const summary = MediaIngest.useSummary();

  function _onClosePress() {
    navigate(`/volume/${volumeId}${path}`);
  }

  let detail = '';
  let success = '';
  let skipped = '';
  let failure = '';
  if (summary) {
    const { file_count, success_count, fail_count, skip_count } = summary;
    const { total_size, success_size, fail_size, skip_size } = summary;
    detail = `${file_count} Total, ${byteFormat(total_size)}`;
    success = `${success_count} files, ${byteFormat(success_size)}`;
    skipped = `${skip_count} files, ${byteFormat(skip_size)}`;
    failure = `${fail_count} files, ${byteFormat(fail_size)}`;
  }

  const rows = list.map((upload) => {
    return {
      list: [
        upload.name,
        upload.dir || '-',
        byteFormat(upload.file_size),
        upload.status,
        upload.last_err,
      ],
    };
  });
  return (
    <>
      <TitleActionLine title='Upload: status'>
        <TextButton text='Close' onPress={_onClosePress} />
      </TitleActionLine>
      <StandardBoxList title='Summary'>
        <PropList
          columns={[
            [
              {
                label: 'Destination',
                value: path,
              },
            ],
            [
              {
                label: 'Succeeded',
                value: success,
              },
              {
                label: 'Skipped',
                value: skipped,
              },
            ],
            [
              {
                label: 'Failed',
                value: failure,
              },
            ],
          ]}
        />
      </StandardBoxList>
      <StandardBoxList
        title='Files'
        detail={detail}
        headers={['Name', 'Folder', 'Size', 'Status', 'Error']}
        sizes={[1, 1, 1, 1, 3]}
        rows={rows}
      />
    </>
  );
}
